import { HelpOutline as HelpIcon } from '@mui/icons-material';
import { Tooltip, TooltipProps } from '@mui/material';

type Props = Omit<TooltipProps, 'children'>;

export const HelpTooltip = (tooltipProps: Props) => (
  <Tooltip {...tooltipProps}>
    <HelpIcon fontSize="small" color="secondary" sx={{ ml: 1 }} />
  </Tooltip>
);
